<div class="row">
  <div class="col-12 d-flex flex-wrap justify-content-center">

    <div class="effectif-container mx-4 my-2 col-lg-5 col-12">
      <q-effectifs [Option]="OptionClient" [ListEffectifChecked]="lstEffectifsSelected" (EffectifToEmit)="UpdateListEffectif($event)">
        <ng-template let-Effectif #mytemplate>
          <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
          <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
        </ng-template>
      </q-effectifs>
    </div>

    <div class="effectif-container mx-4 my-2 col-lg-5 col-12">
      <q-effectifs [Option]="OptionStagiaire" [ListEffectifChecked]="lstEffectifsSelected" (EffectifToEmit)="UpdateListEffectif($event)">
        <ng-template let-Effectif #mytemplate>
          <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
          <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
        </ng-template>
      </q-effectifs>
    </div>

    <div class="effectif-container mx-4 my-2 col-lg-5 col-12">
      <q-effectifs [Option]="OptionFormateur" [ListEffectifChecked]="lstEffectifsSelected" (EffectifToEmit)="UpdateListEffectif($event)">
        <ng-template let-Effectif #mytemplate>
          <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
          <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
        </ng-template>
      </q-effectifs>
    </div>

    <div class="effectif-container mx-4 my-2 col-lg-5 col-12">
      <q-effectifs [Option]="OptionResponsables" [ListEffectifChecked]="lstEffectifsSelected" (EffectifToEmit)="UpdateListEffectif($event)">
        <ng-template let-Effectif #mytemplate>
          <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
          <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
        </ng-template>
      </q-effectifs>
    </div>

    <div class="effectif-container mx-4 my-2 col-lg-5 col-12">
      <q-effectifs [Option]="OptionPreinscrits" [ListEffectifChecked]="lstEffectifsSelected" (EffectifToEmit)="UpdateListEffectif($event)">
        <ng-template let-Effectif #mytemplate>
          <div *ngIf="Effectif.Email else noMail"> {{Effectif.Email}}</div>
          <ng-template #noMail><div class="no-mail">Adresse mail non renseignée</div></ng-template>
    </ng-template>
    </q-effectifs>
  </div>

  </div>
</div>
